@use "../../styles/Constants.scss" as Constants;
@use "../../styles/Colors.scss" as Colors;

@mixin label {
	background-color: Colors.$col-blue;
	padding-left: Constants.$val-spacing-xs;
	padding-right: Constants.$val-spacing-xs;
	color: Colors.$col-white;
	font-weight: bold;
	margin-right: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
	text-transform: uppercase;
	white-space: nowrap;
}

@mixin subjob {
	background-color: Colors.$col-design-blue7;
	color: Colors.$col-blue;
	padding-left: Constants.$val-spacing-xs;
	padding-right: Constants.$val-spacing-xs;
	font-weight: bold;
}

@mixin completed {
	background-color: Colors.$col-greyConnection;
	color: Colors.$col-green;
	font-weight: bold;
	text-transform: none;
	padding: Constants.$val-spacing-xs;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeXSmall;
}

@mixin opened {
	background-color: Colors.$col-greyConnection;
	color: Colors.$col-black;
	font-weight: bold;
	text-transform: none;
	padding: Constants.$val-spacing-xs;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeXSmall;
}

@mixin unfinished {
	background-color: Colors.$col-greyConnection;
	color: Colors.$col-red;
	font-weight: bold;
	text-transform: none;
	padding: Constants.$val-spacing-xs;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: Constants.$val-fontSizeXSmall;
	margin-top: Constants.$val-spacing-s;
}

@mixin pending {
	background-color: Colors.$col-greyConnection;
	color: Colors.$color-apricot;
	font-weight: bold;
	text-transform: none;
	padding: Constants.$val-spacing-xs;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: Constants.$val-fontSizeXSmall;
	margin-top: Constants.$val-spacing-s;
}

@mixin inactive {
	background-color: Colors.$col-greyConnection;
	color: Colors.$col-grey;
	font-weight: bold;
	text-transform: none;
	padding: Constants.$val-spacing-xs;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: Constants.$val-fontSizeXSmall;
	margin-top: Constants.$val-spacing-s;
}

.label {
	@include label;

	&__subjob {
		@include label;
		@include subjob;

		&__margin {
			@include label;
			@include subjob;
			margin-right: Constants.$val-spacing-s;
		}
	}

	&__opened {
		@include label;
		@include opened
	}

	&__completed {
		@include label;
		@include completed;

		&__light {
			@include label;
			@include completed;
			background-color: Colors.$col-design-grey13;
		}
	}

	&__inactive {
		@include label;
		@include inactive;

		&__light {
			@include label;
			@include inactive;
			background-color: Colors.$col-design-grey13;
		}
	}

	&__unfinished {
		@include label;
		@include unfinished;
	}

	&__pending {
		@include label;
		@include pending;

		&__light {
			@include label;
			@include pending;
			background-color: Colors.$col-design-grey13;
		}
	}
}